import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//UPDATE ACTION
export const editSegmentPricebook = createAsyncThunk("editSegmentPricebook", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`price-book/segment/${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const SegmentPriceBookEditSlice = createSlice({
	name: "SegmentPriceBookEditSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(editSegmentPricebook.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(editSegmentPricebook.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(editSegmentPricebook.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default SegmentPriceBookEditSlice.reducer;
